import React, { Component } from "react";
import { Tag, Tooltip, Popconfirm, Switch, message } from "antd";
import { EditOutlined, CheckCircleOutlined, StopOutlined, PaperClipOutlined } from "@ant-design/icons";
import { ButtonItem, TableItem } from "../../../../Components/Items";
import { cmmsPost, formatoFecha } from "../cmmsComun";
import { VIGENCIAS } from "./certificadoComun";
import ModalEquipoPatron from "./ModalEquipoPatron";

// Equipos patron (simuladores y analizadores) con su calibracion. Se eligen al emitir cada
// certificado y quedan impresos en el.
class EquiposPatron extends Component {
    state = { loading: false, lista: [], todos: false, modal: false, patron: null };

    componentDidMount() {
        this.consultar();
    }

    consultar = async () => {
        this.setState({ loading: true });
        try {
            const res = await cmmsPost(this.props, "selectEquiposPatronCMMS", { todos: this.state.todos });
            this.setState({ lista: res.data.success === 2 ? res.data.equiposPatron : [] });
        } catch (error) {
            console.log(error);
            message.error("No se pudieron consultar los equipos patrón");
        } finally {
            this.setState({ loading: false });
        }
    };

    cambiarEstado = async (p) => {
        const res = await cmmsPost(this.props, "cambiarEstadoEquipoPatronCMMS", { id: p._id, activo: !p.activo });
        if (res.data.success === 2) this.consultar();
        else message.error(res.data.message || "No se pudo cambiar");
    };

    render() {
        const columns = [
            { title: "Clave", dataIndex: "clave", key: "clave", buscar: "clave", width: 110 },
            { title: "Tipo", dataIndex: "tipo", key: "tipo", width: 150 },
            { title: "Marca", dataIndex: "marca", key: "marca", buscar: "marca", width: 170 },
            { title: "Modelo", dataIndex: "modelo", key: "modelo", buscar: "modelo", width: 170, render: (v, r) => (r.activo ? v : <span style={{ color: "#9aa7b4" }}>{v} (deshabilitado)</span>) },
            { title: "No. serie", dataIndex: "numeroSerie", key: "numeroSerie", buscar: "numeroSerie", width: 130 },
            { title: "Certificado", dataIndex: "certificado", key: "certificado", width: 150 },
            { title: "Calibración", dataIndex: "fechaCalibracion", key: "fechaCalibracion", width: 110, render: (v) => formatoFecha(v) },
            {
                title: "Próxima calibración",
                dataIndex: "proximaCalibracion",
                key: "proximaCalibracion",
                width: 170,
                render: (v, r) =>
                    v ? (
                        <span>
                            {formatoFecha(v)} {r.estatusCalibracion && <Tag color={VIGENCIAS[r.estatusCalibracion].color}>{r.estatusCalibracion === "vigente" ? "Vigente" : VIGENCIAS[r.estatusCalibracion].label}</Tag>}
                        </span>
                    ) : (
                        <Tag>Sin fecha</Tag>
                    ),
            },
            {
                title: "Archivo",
                dataIndex: "archivo",
                key: "archivo",
                width: 80,
                align: "center",
                render: (v) =>
                    v?.[0]?.url ? (
                        <a href={v[0].url} target="_blank" rel="noopener noreferrer" title={v[0].name}>
                            <PaperClipOutlined />
                        </a>
                    ) : null,
            },
            {
                title: "Acción",
                key: "accion",
                fixed: "right",
                align: "center",
                width: 100,
                onCell: () => ({ className: "acciones-sin-hover", style: { textAlign: "center", padding: "4px" } }),
                render: (r) => (
                    <div className="acciones-container">
                        <Tooltip title="Editar">
                            <ButtonItem type="default" size="small" cyan icon={<EditOutlined />} onClick={() => this.setState({ modal: true, patron: r })} />
                        </Tooltip>
                        <Popconfirm title={r.activo ? "¿Deshabilitar? Ya no se podrá elegir en certificados nuevos." : "¿Habilitar de nuevo?"} onConfirm={() => this.cambiarEstado(r)} okText="Sí" cancelText="No">
                            <Tooltip title={r.activo ? "Deshabilitar" : "Habilitar"}>
                                {r.activo ? <ButtonItem type="default" size="small" lima icon={<CheckCircleOutlined />} /> : <ButtonItem type="default" size="small" rojo icon={<StopOutlined />} />}
                            </Tooltip>
                        </Popconfirm>
                    </div>
                ),
            },
        ];
        return (
            <>
                <div className="cmms-filtros" style={{ justifyContent: "space-between" }}>
                    <span style={{ display: "flex", gap: 8, alignItems: "center" }}>
                        <Switch size="small" checked={this.state.todos} onChange={(todos) => this.setState({ todos }, this.consultar)} /> Mostrar deshabilitados
                    </span>
                    <ButtonItem type="primary" olivo onClick={() => this.setState({ modal: true, patron: null })}>
                        Agregar equipo patrón
                    </ButtonItem>
                </div>
                <TableItem
                    loading={this.state.loading}
                    size="small"
                    dataSource={this.state.lista}
                    columns={columns}
                    rowKey="_id"
                    pagination={true}
                    onRow={(r) => ({ onDoubleClick: () => this.setState({ modal: true, patron: r }) })}
                />
                <ModalEquipoPatron visible={this.state.modal} patron={this.state.patron} onClose={(ok) => this.setState({ modal: false }, () => ok && this.consultar())} />
            </>
        );
    }
}

export default EquiposPatron;
